// import React, { useEffect, useState } from "react";
// import Header from "../Header/Header";
// import Footer from "../Header/Footer";
// import axios from "axios";
// import Preloader from "../Preloder/Preloader";
// import { useLocation, useNavigate } from "react-router-dom";

// const Allprofiles = () => {

//   const locate =useLocation()
//   // console.log("locate",locate.state)
//   const navdata=locate.state;
// useEffect(() => {
//   if (navdata) {
//     setAgeRange(navdata.ageRange);
//     setEmployedIn(navdata.employedIn);
//     setJobDescription(navdata.jobDescription);
//     setReligion(navdata.religion);
//     setSelectedCommunity(navdata.community);
//     setSelectedCast(navdata.caste);
//     setLocation(navdata.location);

//     handleFilter({
//       ageRange: navdata.ageRange,
//       employedIn: navdata.employedIn,
//       jobDescription: navdata.jobDescription,
//       religion: navdata.religion,
//       community: navdata.community,
//       caste: navdata.caste,
//       location: navdata.location,
//     });
//   }
// }, [navdata]);

//   const [cast, setCast] = useState([]);
//   const [community, setCommunity] = useState([]);
//   const [ageError, setAgeError] = useState("");
//   const [profilesData, setProfilesData] = useState([]);

//   // -----------------------------
//   // STATES FOR ALL FILTER INPUTS
//   // -----------------------------
//   const [ageRange, setAgeRange] = useState("");
//   const [employedIn, setEmployedIn] = useState("");
//   const [jobDescription, setJobDescription] = useState("");
//  const [religion, setReligion] = useState("");
//   const [selectedCommunity, setSelectedCommunity] = useState("");
//   const [selectedCast, setSelectedCast] = useState("");
//   const [location, setLocation] = useState("");

//   const [filteredProfiles, setFilteredProfiles] = useState([]);
//   const [loading, setLoading] = useState(false);

//   const apikey = process.env.REACT_APP_API_KEY;
//   const api = process.env.REACT_APP_API;
//   const navigate =useNavigate()
//   // -----------------------------
//   // FETCH PROFILES DATA
//   // -----------------------------
//   useEffect(() => {
//     const username = localStorage.getItem("username");
//     const sex = localStorage.getItem("sex");

//     const getdata = async () => {
//       try {
//         setLoading(true);
//         const response = await axios.post(
//           `${api}/api/das_contant`,
//           { username, sex },
//           {
//             headers: {
//               "x-api-key": apikey,
//               "Content-Type": "application/json",
//             },
//           }
//         );

//         const mappedProfiles = response.data.opposite_data.map((p) => ({
//           id: p.id,
//           name: p.full_name || "No Name",
//           age: p.age || "N/A",
//           height: p.height || "N/A",
//           job: p.occupation || "N/A",
//           education: p.education || "N/A",
//           user_photo: p.user_photo || null,
//           is_online: false,
//           last_seen: "Unknown",
//         }));

//         setProfilesData(mappedProfiles); // all profiles
//         setFilteredProfiles(mappedProfiles); // initially show all
//       } catch (err) {
//         console.log("API error:", err);
//       } finally {
//         setLoading(false);
//       }
//     };

//     getdata();
//   }, [api, apikey]);

//   // -----------------------------
//   // FETCH CASTE + COMMUNITY
//   // -----------------------------
//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const [casteRes, communityRes] = await Promise.all([
//           axios.get("https://matrimony.bugchat.in/api/getcaste", {
//             headers: { "x-api-key": apikey },
//           }),
//           axios.get("https://matrimony.bugchat.in/api/getcommunity", {
//             headers: { "x-api-key": apikey },
//           }),
//         ]);

//         setCast(casteRes.data?.caste_list || []);
//         setCommunity(communityRes.data?.caste_list || []);
//       } catch (error) {
//         console.error("Error:", error);
//       }
//     };

//     fetchData();
//   }, [apikey]);

//   // -----------------------------
//   // FILTER FUNCTION
//   // -----------------------------
//   const handleFilter = async () => {
//     if (ageRange && Number(ageRange) < 21) {
//       setAgeError("Age must be 21 or above");
//       return;
//     } else {
//       setAgeError("");
//     }

//     setLoading(true);
//     const sex =localStorage.getItem('sex')
//     const payload = {
//       ageRange,
//       employedIn,
//       jobDescription,
//       religion: religion,
//       community: selectedCommunity,
//       caste: selectedCast,
//       location,
//       sex,
//     };
  
//     try {
//       const res = await axios.post(
//         "https://matrimony.bugchat.in/api/filter_profile",
//         payload,
//         { headers: { "x-api-key": apikey } }
//       );

//       const mappedProfiles = (res.data?.profiles || []).map((p) => ({
//         id: p.id,
//         name: p.full_name || "No Name",
//         age: p.age || "N/A",
//         height: p.height || "N/A",
//         job: p.employeid || "N/A",
//         education: p.education || "N/A",
//         user_photo: p.user_photo || null,
//         is_online: false,
//         last_seen: "Unknown",
//       }));

//       setFilteredProfiles(mappedProfiles); // filtered profiles, can be empty
//     } catch (error) {
//       console.error("Filter error:", error);
//       setFilteredProfiles([]); // empty on error
//     } finally {
//       setLoading(false);
//     }
//   };

//   // -----------------------------
//   // RENDER
//   // -----------------------------



//     const handleViewProfile = async (id) => {
//     const api = process.env.REACT_APP_API;
//     const apikey = process.env.REACT_APP_API_KEY;
//     try {
//       const response = await axios.get(`${api}/api/viewprofile/${id}`, {
//         headers: {
//           "x-api-key": apikey,
//           "Content-Type": "application/json",
//         },
//       });
//       if (response.data.status === "Success") {
//         navigate("/user/viewprofile", { state: response.data.user });
//       }
//       // return response.data; // optional, but useful
//       // console.log(response.data )
//     } catch (error) {
//       console.error("Error viewing profile:", error);
//       throw error; // optional but recommended
//     }
//   };
//   return (
//     <div>
//       {loading && <Preloader />}
//       <Header />

//       {/* TOP SECTION */}
//       <section>
//         <div className="all-pro-head">
//           <div className="container">
//             <div className="row">
//               <h1>Lakhs of Happy Marriages</h1>
//               <a href="sign-up.html">
//                 Join now for Free <i className="fa fa-handshake-o"></i>
//               </a>
//             </div>
//           </div>
//         </div>

//         <div className="fil-mob fil-mob-act">
//           <h4>
//             Profile filters <i className="fa fa-filter"></i>{" "}
//           </h4>
//         </div>
//       </section>

//       {/* MAIN CONTENT */}
//       <section>
//         <div className="all-weddpro all-jobs all-serexp chosenini">
//           <div className="container">
//             <div className="row">
//               {/* LEFT FILTERS */}
//               <div className="col-md-3 fil-mob-view">
//                 <span className="filter-clo">+</span>

//                 {/* AGE */}
//                 <div className="filt-com lhs-cate">
//                   <h4>
//                     <i className="fa fa-clock-o"></i>Age
//                   </h4>
//                   <div className="form-group">
//                     <input
//                       type="number"
//                       placeholder="Enter age above 21"
//                       min="21"
//                       value={ageRange}
//                       onChange={(e) => {
//                         const value = e.target.value;
//                         setAgeRange(value);
//                         if (value && Number(value) < 21) {
//                           setAgeError("Age must be 21 or above");
//                         } else {
//                           setAgeError("");
//                         }
//                       }}
//                     />
//                     {ageError && (
//                       <p
//                         style={{
//                           color: "red",
//                           fontSize: "13px",
//                           marginTop: "5px",
//                         }}
//                       >
//                         {ageError}
//                       </p>
//                     )}
//                   </div>
//                 </div>

//                 {/* JOB TYPE */}
//                 <div className="filt-com lhs-cate">
//                   <h4>
//                     <i className="fa fa-search"></i> job
//                   </h4>
//                   <div className="form-group">
//                     <select
//                     //   className="chosen-select"
//                       value={employedIn}
//                       onChange={(e) => setEmployedIn(e.target.value)}
//                     >
//                       <option value="">Select</option>
//                       <option value="Business">Business</option>
//                       <option value="Defence">Defence</option>
//                       <option value="Government/PSC">Government / PSC</option>
//                       <option value="MNC">MNC</option>
//                       <option value="Private">Private</option>
//                       <option value="Self-Employed">Self-Employed</option>
//                       <option value="Not Working">Not Working</option>
//                     </select>
//                   </div>
//                 </div>

//                 {/* JOB DESCRIPTION */}
//                 <div className="filt-com lhs-cate">
//                   <h4>
//                     <i className="fa fa-search"></i> Job Description{" "}
//                   </h4>
//                   <div className="form-group">
//                     <input
//                       type="text"
//                       placeholder="Job Description"
//                       value={jobDescription}
//                       onChange={(e) => setJobDescription(e.target.value)}
//                     />
//                   </div>
//                 </div>

//                 {/* RELIGION */}
//                 <div className="filt-com lhs-cate">
//                   <h4>
//                     <i className="fa fa-bell-o"></i>Select Religion
//                   </h4>
//                   <div className="form-group">
                   
// <select
// //   className="chosen-select"
//   value={religion}
//   onChange={(e) => setReligion(e.target.value)}
// >
//   <option value="">Select</option>
//   <option value="Hindu">Hindu</option>
//   <option value="Muslim">Muslim</option>
//   <option value="Christian">Christian</option>
//   <option value="Sikh">Sikh</option>
//   <option value="Buddhist">Buddhist</option>
//   <option value="Jain">Jain</option>
//   <option value="Other">Other</option>
// </select>
//                   </div>
//                 </div>

//                 {/* COMMUNITY */}
//                 <div className="filt-com lhs-cate">
//                   <h4>
//                     <i className="fa fa-bell-o"></i>Select Community
//                   </h4>
//                   <div className="form-group">
//                     <select
//                       value={selectedCommunity}
//                       onChange={(e) => setSelectedCommunity(e.target.value)}
//                     >
//                       <option value="">Select Community</option>
//                       {community.map((item) => (
//                         <option key={item.id} value={item.community_name}>
//                           {item.community_name}
//                         </option>
//                       ))}
//                     </select>
//                   </div>
//                 </div>

//                 {/* CASTE */}
//                 <div className="filt-com lhs-cate">
//                   <h4>
//                     <i className="fa fa-bell-o"></i>Select cast
//                   </h4>
//                   <div className="form-group">
//                     {cast.length > 0 ? (
//                       <select
//                         value={selectedCast}
//                         onChange={(e) => setSelectedCast(e.target.value)}
//                       >
//                         <option value="">Select Caste</option>
//                         {cast.map((c) => (
//                           <option key={c.id} value={c.caste_name}>
//                             {c.caste_name}
//                           </option>
//                         ))}
//                       </select>
//                     ) : (
//                       <p>Loading caste...</p>
//                     )}
//                   </div>
//                 </div>

//                 {/* LOCATION */}
//                 <div className="filt-com lhs-cate">
//                   <h4>
//                     <i className="fa fa-map-marker"></i>Location
//                   </h4>
//                   <div className="form-group">
//                     <input
//                       type="text"
//                       value={location}
//                       onChange={(e) => setLocation(e.target.value)}
//                     />
//                   </div>
//                 </div>

//                 {/* FILTER BUTTON */}
//                 <button
//                   onClick={handleFilter}
//                   className="btn btn-primary"
//                   style={{ width: "100%", marginTop: 15 }}
//                 >
//                   Apply Filter
//                 </button>
//               </div>

//               {/* RIGHT SIDE PROFILES */}
//               <div className="col-md-9">
//                 <div className="short-all">
//                   <div className="short-lhs">
//                     Showing <b>{filteredProfiles.length}</b> profiles
//                   </div>
//                 </div>

//                 <div className="all-list-sh">
//                   <ul>
//                     {filteredProfiles.length > 0 ? (
//                       filteredProfiles.map((pro) => (
//                         <li key={pro.id}>
//                           <div className="all-pro-box user-avil-onli">
//                             <div className="pro-img">
//                               <a href="#!">
//                                 <img
//                                   src={
//                                     pro.user_photo
//                                       ? `${api}/uploads/${pro.user_photo}`
//                                       : process.env.PUBLIC_URL +
//                                         "/images/user/user.png"
//                                   }
//                                   alt=""
//                                 />
//                               </a>

//                               <div className="pro-avl-status">
//                                 {pro.is_online ? (
//                                   <h5>Available Online</h5>
//                                 ) : (
//                                   <span className="marqu">{pro.last_seen}</span>
//                                 )}
//                               </div>
//                             </div>

//                             <div className="pro-detail">
//                               <h4>
//                                 <a href="#!">{pro.name}</a>
//                               </h4>
//                               <div className="pro-bio">
//                                 {/* <span>{pro.education}</span> */}
//                                 <span>{pro.job}</span>
//                                 <span>Age :{pro.age} Years old</span>
//                                 {/* <span>Height: {pro.height}</span> */}
//                               </div>

//                               <div className="links">
//                                 <span className="cta-chat">Chat now</span>
//                                 <a href="#!">WhatsApp</a>
//                                 <a href="#!" className="cta">
//                                   Send interest
//                                 </a>
//                                 <a    onClick={() =>
//                                           handleViewProfile(pro.id)
//                                         }>More details</a>
//                               </div>
//                             </div>

//                             <span className="enq-sav">
//                               <i className="fa fa-thumbs-o-up"></i>
//                             </span>
//                           </div>
//                         </li>
//                       ))
//                     ) : (
//                       <li>
//                         <p
//                           style={{
//                             textAlign: "center",
//                             width: "100%",
//                             padding: "20px",
//                           }}
//                         >
//                           No data found
//                         </p>
//                       </li>
//                     )}
//                   </ul>
//                 </div>
//               </div>
//               {/* END RIGHT SIDE */}
//             </div>
//           </div>
//         </div>
//       </section>

//       <Footer />
//     </div>
//   );
// };

// export default Allprofiles;








import React, { useEffect, useState } from "react";
import Header from "../Header/Header";
import Footer from "../Header/Footer";
import axios from "axios";
import Preloader from "../Preloder/Preloader";
import { useLocation, useNavigate } from "react-router-dom";

const Allprofiles = () => {
  const locate = useLocation();
  const navdata = locate.state;

  // -----------------------------
  // FILTER STATES
  // -----------------------------
  const [ageRange, setAgeRange] = useState("");
  const [employedIn, setEmployedIn] = useState("");
  const [jobDescription, setJobDescription] = useState("");
  const [religion, setReligion] = useState("");
  const [selectedCommunity, setSelectedCommunity] = useState("");
  const [selectedCast, setSelectedCast] = useState("");
  const [location, setLocation] = useState("");

  const [cast, setCast] = useState([]);
  const [community, setCommunity] = useState([]);
  const [ageError, setAgeError] = useState("");
  const [profilesData, setProfilesData] = useState([]);
  const [filteredProfiles, setFilteredProfiles] = useState([]);

  const [loading, setLoading] = useState(false);
  const apikey = process.env.REACT_APP_API_KEY;
  const api = process.env.REACT_APP_API;
  const navigate = useNavigate();

  // -----------------------------
  // APPLY NAVIGATION FILTER VALUES
  // -----------------------------
  useEffect(() => {
    if (navdata) {
      setAgeRange(navdata.ageRange);
      setEmployedIn(navdata.employedIn);
      setJobDescription(navdata.jobDescription);
      setReligion(navdata.religion);
      setSelectedCommunity(navdata.community);
      setSelectedCast(navdata.caste);
      setLocation(navdata.location);

      // Apply filter immediately using navdata values
      handleFilter({
        ageRange: navdata.ageRange,
        employedIn: navdata.employedIn,
        jobDescription: navdata.jobDescription,
        religion: navdata.religion,
        community: navdata.community,
        caste: navdata.caste,
        location: navdata.location,
      });
    }
  }, [navdata]);

  // -----------------------------
  // FETCH PROFILES LIST
  // -----------------------------
  useEffect(() => {
    const username = localStorage.getItem("username");
    const sex = localStorage.getItem("sex");

    const getdata = async () => {
      try {
        setLoading(true);
        const response = await axios.post(
          `${api}/api/das_contant`,
          { username, sex },
          {
            headers: {
              "x-api-key": apikey,
              "Content-Type": "application/json",
            },
          }
        );

        const mappedProfiles = response.data.opposite_data.map((p) => ({
          id: p.id,
          name: p.full_name || "No Name",
          age: p.age || "N/A",
          height: p.height || "N/A",
          job: p.occupation || "N/A",
          education: p.education || "N/A",
          user_photo: p.user_photo || null,
          is_online: false,
          last_seen: "Unknown",
        }));

        setProfilesData(mappedProfiles);
        setFilteredProfiles(mappedProfiles);
      } catch (err) {
        console.log("API error:", err);
      } finally {
        setLoading(false);
      }
    };

    getdata();
  }, [api, apikey,!navdata]);

  // -----------------------------
  // FETCH CAST + COMMUNITY
  // -----------------------------
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [casteRes, communityRes] = await Promise.all([
          axios.get("https://matrimony.bugchat.in/api/getcaste", {
            headers: { "x-api-key": apikey },
          }),
          axios.get("https://matrimony.bugchat.in/api/getcommunity", {
            headers: { "x-api-key": apikey },
          }),
        ]);

        setCast(casteRes.data?.caste_list || []);
        setCommunity(communityRes.data?.caste_list || []);
      } catch (error) {
        console.error("Error:", error);
      }
    };

    fetchData();
  }, [apikey]);

  // -----------------------------
  // FILTER PROFILES
  // -----------------------------
  const handleFilter = async (manualValues = null) => {
    const values = manualValues || {
      ageRange,
      employedIn,
      jobDescription,
      religion,
      community: selectedCommunity,
      caste: selectedCast,
      location,
    };

    if (values.ageRange && Number(values.ageRange) < 21) {
      setAgeError("Age must be 21 or above");
      return;
    } else {
      setAgeError("");
    }

    setLoading(true);
    const sex = localStorage.getItem("sex");

    const payload = {
      ...values,
      sex,
    };

    try {
      const res = await axios.post(
        "https://matrimony.bugchat.in/api/filter_profile",
        payload,
        { headers: { "x-api-key": apikey } }
      );

      const mappedProfiles = (res.data?.profiles || []).map((p) => ({
        id: p.id,
        name: p.full_name || "No Name",
        age: p.age || "N/A",
        height: p.height || "N/A",
        job: p.employeid || "N/A",
        education: p.education || "N/A",
        user_photo: p.user_photo || null,
        is_online: false,
        last_seen: "Unknown",
      }));

      setFilteredProfiles(mappedProfiles);
    } catch (error) {
      console.error("Filter error:", error);
      setFilteredProfiles([]);
    } finally {
      setLoading(false);
    }
  };

  // -----------------------------
  // VIEW PROFILE
  // -----------------------------
  const handleViewProfile = async (id) => {
    try {
      const response = await axios.get(`${api}/api/viewprofile/${id}`, {
        headers: {
          "x-api-key": apikey,
          "Content-Type": "application/json",
        },
      });

      if (response.data.status === "Success") {
        navigate("/user/viewprofile", { state: response.data.user });
      }
    } catch (error) {
      console.error("Error viewing profile:", error);
    }
  };

  // -----------------------------
  // RENDER UI
  // -----------------------------
  return (
    <div>
      {loading && <Preloader />}
      <Header />

      {/* TOP SECTION */}
      <section>
        <div className="all-pro-head">
          <div className="container">
            <div className="row">
              <h1>Lakhs of Happy Marriages</h1>
              <a href="sign-up.html">
                Join now for Free <i className="fa fa-handshake-o"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="fil-mob fil-mob-act">
          <h4>
            Profile filters <i className="fa fa-filter"></i>{" "}
          </h4>
        </div>
      </section>

      {/* MAIN CONTENT */}
      <section>
        <div className="all-weddpro all-jobs all-serexp chosenini">
          <div className="container">
            <div className="row">
              {/* LEFT FILTERS */}
              <div className="col-md-3 fil-mob-view">
                <span className="filter-clo">+</span>

                {/* AGE */}
                <div className="filt-com lhs-cate">
                  <h4>
                    <i className="fa fa-clock-o"></i>Age
                  </h4>
                  <div className="form-group">
                    <input
                      type="number"
                      placeholder="Enter age above 21"
                      min="21"
                      value={ageRange}
                      onChange={(e) => {
                        const value = e.target.value;
                        setAgeRange(value);
                        if (value && Number(value) < 21) {
                          setAgeError("Age must be 21 or above");
                        } else {
                          setAgeError("");
                        }
                      }}
                    />
                    {ageError && (
                      <p
                        style={{
                          color: "red",
                          fontSize: "13px",
                          marginTop: "5px",
                        }}
                      >
                        {ageError}
                      </p>
                    )}
                  </div>
                </div>

                {/* JOB TYPE */}
                <div className="filt-com lhs-cate">
                  <h4>
                    <i className="fa fa-search"></i> job
                  </h4>
                  <div className="form-group">
                    <select
                      value={employedIn}
                      onChange={(e) => setEmployedIn(e.target.value)}
                    >
                      <option value="">Select</option>
                      <option value="Business">Business</option>
                      <option value="Defence">Defence</option>
                      <option value="Government/PSC">Government / PSC</option>
                      <option value="MNC">MNC</option>
                      <option value="Private">Private</option>
                      <option value="Self-Employed">Self-Employed</option>
                      <option value="Not Working">Not Working</option>
                    </select>
                  </div>
                </div>

                {/* JOB DESCRIPTION */}
                <div className="filt-com lhs-cate">
                  <h4>
                    <i className="fa fa-search"></i> Job Description{" "}
                  </h4>
                  <div className="form-group">
                    <input
                      type="text"
                      placeholder="Job Description"
                      value={jobDescription}
                      onChange={(e) => setJobDescription(e.target.value)}
                    />
                  </div>
                </div>

                {/* RELIGION */}
                <div className="filt-com lhs-cate">
                  <h4>
                    <i className="fa fa-bell-o"></i>Select Religion
                  </h4>
                  <div className="form-group">
                    <select
                      value={religion}
                      onChange={(e) => setReligion(e.target.value)}
                    >
                      <option value="">Select</option>
                      <option value="Hindu">Hindu</option>
                      <option value="Muslim">Muslim</option>
                      <option value="Christian">Christian</option>
                      <option value="Sikh">Sikh</option>
                      <option value="Buddhist">Buddhist</option>
                      <option value="Jain">Jain</option>
                      <option value="Other">Other</option>
                    </select>
                  </div>
                </div>

                {/* COMMUNITY */}
                <div className="filt-com lhs-cate">
                  <h4>
                    <i className="fa fa-bell-o"></i>Select Community
                  </h4>
                  <div className="form-group">
                    <select
                      value={selectedCommunity}
                      onChange={(e) => setSelectedCommunity(e.target.value)}
                    >
                      <option value="">Select Community</option>
                      {community.map((item) => (
                        <option key={item.id} value={item.community_name}>
                          {item.community_name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                {/* CASTE */}
                <div className="filt-com lhs-cate">
                  <h4>
                    <i className="fa fa-bell-o"></i>Select cast
                  </h4>
                  <div className="form-group">
                    {cast.length > 0 ? (
                      <select
                        value={selectedCast}
                        onChange={(e) => setSelectedCast(e.target.value)}
                      >
                        <option value="">Select Caste</option>
                        {cast.map((c) => (
                          <option key={c.id} value={c.caste_name}>
                            {c.caste_name}
                          </option>
                        ))}
                      </select>
                    ) : (
                      <p>Loading caste...</p>
                    )}
                  </div>
                </div>

                {/* LOCATION */}
                <div className="filt-com lhs-cate">
                  <h4>
                    <i className="fa fa-map-marker"></i>Location
                  </h4>
                  <div className="form-group">
                    <input
                      type="text"
                      value={location}
                      onChange={(e) => setLocation(e.target.value)}
                    />
                  </div>
                </div>

                <button
                  onClick={() =>
                    handleFilter({
                      ageRange,
                      employedIn,
                      jobDescription,
                      religion,
                      community: selectedCommunity,
                      caste: selectedCast,
                      location,
                    })
                  }
                  className="btn btn-primary"
                  style={{ width: "100%", marginTop: 15 }}
                >
                  Apply Filter
                </button>
              </div>

              {/* RIGHT SIDE: PROFILE LIST */}
              <div className="col-md-9">
                <div className="short-all">
                  <div className="short-lhs">
                    Showing <b>{filteredProfiles.length}</b> profiles
                  </div>
                </div>

                <div className="all-list-sh">
                  <ul>
                    {filteredProfiles.length > 0 ? (
                      filteredProfiles.map((pro) => (
                        <li key={pro.id}>
                          <div className="all-pro-box user-avil-onli">
                            <div className="pro-img">
                              <a href="#!">
                                <img
                                  src={
                                    pro.user_photo
                                      ? `${api}/uploads/${pro.user_photo}`
                                      : process.env.PUBLIC_URL +
                                        "/images/user/user.png"
                                  }
                                  alt=""
                                />
                              </a>

                              <div className="pro-avl-status">
                                {pro.is_online ? (
                                  <h5>Available Online</h5>
                                ) : (
                                  <span className="marqu">{pro.last_seen}</span>
                                )}
                              </div>
                            </div>

                            <div className="pro-detail">
                              <h4>
                                <a href="#!">{pro.name}</a>
                              </h4>
                              <div className="pro-bio">
                                <span>{pro.job}</span>
                                <span>Age :{pro.age} Years old</span>
                              </div>

                              <div className="links">
                                <span className="cta-chat">Chat now</span>
                                <a href="#!">WhatsApp</a>
                                <a href="#!" className="cta">Send interest</a>

                                <a
                                  onClick={() => handleViewProfile(pro.id)}
                                >
                                  More details
                                </a>
                              </div>
                            </div>

                            <span className="enq-sav">
                              <i className="fa fa-thumbs-o-up"></i>
                            </span>
                          </div>
                        </li>
                      ))
                    ) : (
                      <li>
                        <p
                          style={{
                            textAlign: "center",
                            width: "100%",
                            padding: "20px",
                          }}
                        >
                          No data found
                        </p>
                      </li>
                    )}
                  </ul>
                </div>
              </div>
              {/* END RIGHT SIDE */}
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Allprofiles;
